import { render, staticRenderFns } from "./OdontogramaForm.vue?vue&type=template&id=29f511d4&scoped=true"
import script from "./OdontogramaForm.vue?vue&type=script&lang=js"
export * from "./OdontogramaForm.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaForm.vue?vue&type=style&index=0&id=29f511d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f511d4",
  null
  
)

export default component.exports